import { j as t } from "./utils-BdNIfrGQ.js";
import { u as d, a as u, b as c, c as l, d as m, e as f, f as p } from "./toast-DrFMmSLk.js";
import { useState as x, useEffect as T } from "react";
import { createPortal as j } from "react-dom";
function y() {
  const { toasts: a } = d(), [e] = x(() => {
    if (typeof document < "u") {
      const o = document.createElement("div");
      return o.setAttribute("data-toast-portal", ""), o;
    }
    return null;
  });
  return T(() => {
    if (e && typeof document < "u")
      return document.body.appendChild(e), () => {
        document.body.removeChild(e);
      };
  }, [e]), e ? j(
    /* @__PURE__ */ t.jsxs(u, { children: [
      a.map(function({ id: o, title: s, description: r, action: n, ...i }) {
        return /* @__PURE__ */ t.jsxs(c, { ...i, children: [
          /* @__PURE__ */ t.jsxs("div", { className: "grid gap-1", children: [
            s && /* @__PURE__ */ t.jsx(l, { children: s }),
            r && /* @__PURE__ */ t.jsx(m, { children: r })
          ] }),
          n,
          /* @__PURE__ */ t.jsx(f, {})
        ] }, o);
      }),
      /* @__PURE__ */ t.jsx(p, { className: "fixed bottom-0 right-0 z-[100] flex flex-col gap-2 w-full max-w-[420px] p-4" })
    ] }),
    e
  ) : null;
}
export {
  y as T
};
